module.exports = __webpack_public_path__ + "images/category_lp/trading_card/main-view_770d923bc1ba82725d68f86549ffd0d8.png";